import React from "react";
import { isFeatureEnabled } from "utility/isFeatureEnabled";

import { AccountApplicationHistory } from "./AccountApplicationHistory";
import { LegacyAccountLottery } from "./LegacyAccountLottery";

export const AccountLottery: React.FC = () => {
  const isResaleEnabled = isFeatureEnabled({
    featureName: "useReSale",
  });

  return isResaleEnabled ? (
    <AccountApplicationHistory />
  ) : (
    <LegacyAccountLottery />
  );
};
